import CloseIcon from '@mui/icons-material/Close'
import { GenericModalHeadline } from 'src/mentor/components/MentorAvailabilityPage/MentorAvailabilityPageStyles'
import { GenericDisplayFlex } from 'src/mentor/layout/Styles'

export default function EventFormHeader({ eventFormModalData, onClose, isDisabled }) {
  let headerText = 'Edit Event'
  if (isDisabled) {
    headerText = 'View Event'
  } else {
    headerText = Boolean(eventFormModalData) ? 'Edit event' : 'New event'
  }
  return (
    <GenericDisplayFlex sb>
      <GenericModalHeadline>{headerText}</GenericModalHeadline>
      <CloseIcon sx={{ fontSize: 24, color: 'black', cursor: 'pointer' }} onClick={onClose} />
    </GenericDisplayFlex>
  )
}
